import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Gotop from "../../components/gotop";
import JobList from "./JobList";
import CRHeader from "../../components/header/CRHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";


ViewJobs.propTypes = {};

function ViewJobs(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <CRMobileHeader handleMobile={handleMobile} />
            <CRHeader clname="manageJobs" handleMobile={handleMobile} />
            <div className="pt-70">
                <JobList />
                <Gotop />
            </div>
        </>
    );
}

export default ViewJobs;
